import { render, staticRenderFns } from "./ChartSector.vue?vue&type=template&id=6f5bc981&"
import script from "./ChartSector.vue?vue&type=script&lang=js&"
export * from "./ChartSector.vue?vue&type=script&lang=js&"
import style0 from "./ChartSector.vue?vue&type=style&index=0&id=6f5bc981&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports